<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import Bookcard from '@/Pages/Book/Bookcard'
import AfbookLogo from '@/Shared/Icons/AfbookLogo'
import Pagination from '@/Shared/Pagination'
import usePref from '@/Shared/usePref.js'
import useIsotope from '@/Shared/useIsotope.js'

const props = defineProps({
  booksInfo: Object,
  pref: Object,
})

const containerRef = ref()

onMounted(() => {
  usePref(props.pref)
  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: props.booksInfo.data,
    key: 'bookThumb',
  })
})

onUnmounted(() => {})
</script>

<template>
  <div class="books">
    <Head title="ブックス一覧" />

    <div class="relative lg:grid items-center mb-[50px] sm:mb-[100px] xl:mb-[80px]">
      <div class="relative w-full md:h-[530px] 2xl:h-[35vw] sm:mb-[20px] lg:mb-0">
        <img src="https://img.aandf.co.jp/aandfcojp/img/books/kv_sp.webp" alt="A&F Books" class="block w-full h-full md:hidden" />
        <img src="https://img.aandf.co.jp/aandfcojp/img/books/kv.webp" alt="A&F Books" class="hidden w-full h-full object-cover md:block md:object-right lg:object-center xl:object-[55%] 2xl:lg:object-center" />
      </div>
      <div class="lg:absolute lg:top-1/2 lg:translate-y-[-50%] lg:text-left lg:left-[7%] 2xl:left-[10%]">
        <h2 class="page-title mx-auto max-w-full px-[40px] lg:px-0 lg:mx-0 w-[400px] sm:w-[450px] lg:w-[400px] 2xl:w-[450px] lg:text-[125px] lg:text-left !pb-[30px] !pt-[50px] lg:!pt-0">
          <span class="block lg:hidden"><AfbookLogo type="black" /></span>
          <span class="hidden lg:block"><AfbookLogo type="white" /></span>
          <small class="!mt-[1em] lg:text-white">A&amp;Fブックス</small>
        </h2>
        <div class="text-black-shadow mx-auto lg:text-white text-center lg:text-left lg:font-medium mb-[50px] md:mb-[100px] lg:mb-0 leading-[2] text-[calc(5px_+_2.4vw)] xs:text-[15px] [&>p]:mb-[20px] lg:[&>p]:mb-[0.4em]">
          <p>アメリカよりアウトドアの<br class="block md:hidden" />スピリッツと道具類が<br class="hidden md:block" />日本へ紹介され、<br class="block md:hidden" />約40年が経過しました。</p>
          <p>多彩な日本のフィールドで<br class="block md:hidden" />培われてきた<br class="hidden md:block" />アウトドアライフも、<br class="block md:hidden" />独自の発展をしています。</p>
          <p>いつまでも好奇心を忘れないために、<br />知識欲を刺激する独自の出版をしていきます。</p>
          <p>選りすぐれた本を出していきますので、<br class="block md:hidden" />これから乞うご期待ください。</p>
        </div>
      </div>
    </div>

    <div class="mt-[-10px] sm:mt-[-30px] px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-[40px] max-w-[600px] sm:max-w-[1000px] 2xl:max-w-[1200px] 3xl:max-w-[1400px] mx-auto">
      <div ref="containerRef" class="isotope-container m-[-2.5vw] xs:m-[-15px] md:m-[-20px] lg:my-[-25px] lg:mx-0">
        <div v-for="book in props.booksInfo.data" :key="book.bookID" class="isotope-item w-1/2 sm:w-1/3 lg:w-1/3 2xl:w-1/4 3xl:w-1/5 p-[2.5vw] xs:p-[15px] md:p-[20px] lg:p-[25px]">
          <Bookcard :info="book" class="hover-item" />
        </div>
      </div>
    </div>
    <pagination class="mt-6" :links="booksInfo.links" />
  </div>
</template>
